import { TableColumn } from "../../types";

const providerLabelMap = {
  // Location
  aws: "AWS",
  azure: "Azure",
  byok: "BYOK",
  equinix: "Equinix",
  gcp: "GCP",
  oci: "OCI",
  // Cloud account
  ngs: "NGS",
  // Mk8s
  digitalocean: "Digital Ocean",
  ephemeral: "Ephemeral",
  generic: "Generic",
  hetzner: "Hetzner",
  lambdalabs: "Lambdalabs",
  linode: "Linode",
  oblivus: "Oblivus",
  paperspace: "Paperspace",
  triton: "Triton",
};
const providerDefault = { id: "provider", label: "Provider" };
export function ProviderColumn<TData extends { provider: string }>(column: TableColumn<TData> = providerDefault) {
  const preset: TableColumn<TData> = {
    ...providerDefault,
    enableResize: false,
    enableHide: true,
    canGroupByDistinctValues: true,
    groupLabelMap: providerLabelMap,
    groupOrder: Object.keys(providerLabelMap).toSorted(),
    size: 210,
    cell: (p) => {
      const item = p.row.original;
      return <span>{providerLabelMap[item.provider]}</span>;
    },
  };
  return Object.assign(preset, column);
}
